<template>
  <template v-for="(item, idx) in actions" :key="idx">
    <Menu.Item
      v-if="item.type === 'action'"
      :icon="item.icon"
      :label="item.label"
      :variant="item.variant"
      :disabled="item.disabled"
      @click="item.onClick"
    />
    <Menu.RouteItem
      v-else-if="item.type === 'route'"
      :icon="item.icon"
      :label="item.label"
      :disabled="item.disabled"
      :to="item.to"
    />
    <Menu.LinkItem
      v-else-if="item.type === 'link'"
      :icon="item.icon"
      :label="item.label"
      :href="item.href"
    />
    <Menu.Divider v-else-if="item.type === 'divider'" />
  </template>
</template>

<script setup lang="ts">
import Menu from "@/design_system/Menu";

import type { SubmenuActionItem } from "../types/overflow";

type UnwrapArray<T> = T extends (infer V)[] ? V : never;

type DesktopAction = UnwrapArray<SubmenuActionItem["desktop"]>;
type MobileAction = UnwrapArray<SubmenuActionItem["mobile"]>;
type Action = DesktopAction | MobileAction;

defineProps<{
  actions: Action[];
}>();
</script>
